export default __webpack_public_path__ + "static/media/hht1_ep12_timeline_06.a0065b68.png";